var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_265",
    "data-name": "Grupo 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_329",
    "data-name": "Rect\\xE1ngulo 329",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_664",
    "data-name": "Trazado 664",
    d: "M14.252,12.151l-1.54-1.468-.674-.675,2.214-2.215a.723.723,0,0,0,0-1.021l-1.02-1.021a.723.723,0,0,0-1.021,0L10,7.966,7.788,5.751a.723.723,0,0,0-1.021,0L5.747,6.772a.723.723,0,0,0,0,1.021l2.214,2.215-.674.675-1.54,1.468a.724.724,0,0,0,0,1.021l1.031,1.077a.724.724,0,0,0,1.021,0l2.2-2.2,2.2,2.2a.724.724,0,0,0,1.021,0l1.031-1.077a.724.724,0,0,0,0-1.021",
    fill: "#ff784e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_665",
    "data-name": "Trazado 665",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,18.125A8.125,8.125,0,1,1,18.125,10,8.125,8.125,0,0,1,10,18.125",
    fill: "#20164d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX);
export default __webpack_public_path__ + "static/media/circle_x.dccb1fbf29d2af7a4a204a46f45d54fd.svg";
export { ForwardRef as ReactComponent };